module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAGFBMVEUAAAD///////////////////////////8jfp1fAAAAB3RSTlMASzsFQiAYJCKMCAAAAHpJREFUWMPt2LEJgEAQRNHBQ/M9NHc7uEDMxQa0A8EibN8GDG7AwJWZ/CXLRh9o3aqXNyC5EcsFTX+ievMyYl9BbBrgBwO6DCsMSAYDNQEBAYG/getxscAHzyqgb41zVgF9a5yzCggICLwO6IhAZwo6hNCphY45dC66Ae5BmN/tv1gwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/header_zhedie_h5.png
// module id = 0Aku
// module chunks = 11